<!-- side bar main wrapper -->
<div class="side-nav-bar "
    *ngIf="true"
    [ngClass]="{ 'side-nav-bar-collapsed': !(showSideNav | async) }">
    
    <!-- overlay -->
    <!-- <div class="side-nav-bar-overlay" 
    [ngStyle]="{ 'transition': 'background-color ' + duration + 's, visibility ' + duration + 's' }"
    [ngClass]="{ 'side-nav-bar-overlay-collapsed': !(showSideNav | async) }"
        (click)="onSidebarClose()"></div> -->
    
    <!-- side bar-->
    <div class="side-nav-bar-menu-container " 
    [ngStyle]="getSideNavBarStyle((showSideNav | async))"  >
        
        <!-- close button -->
        <!-- <div><span class="material-icons side-nav-bar-close" (click)="onSidebarClose()">
            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" >
                <path  class="cls-1"  d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z" class=""></path>
            </svg>
        </span></div> -->

        <!-- side bar content -->
        <div class="side-nav-bar-content-container">
            <ng-container *ngTemplateOutlet="sidenavTemplateRef"></ng-container>
        </div>
    </div>
</div>

